import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GroovePullquoteDirective } from '@groove/angular';
import type { FunnelQuote } from './funnel-quotes';

@Component({
  selector: 'app-funnel-trust',
  imports: [RouterLink, GroovePullquoteDirective],
  templateUrl: './funnel-trust.component.html',
  styleUrl: './funnel-trust.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FunnelTrustComponent {
  readonly quote = input.required<FunnelQuote>();
}

export type { FunnelQuote };
